export const buildViewTypeFromPathname = (pathname: string): string | null => {
    // first segment is the site slug (e.g. konto-mieszkaniowe) - drop it
    const [, ...segments] = pathname.split("/").filter(Boolean);

    const staticSegments = segments.filter((segment) => !/\d/.test(segment)).map((segment) => segment.replace(/-/g, "_"));

    return staticSegments.length > 0 ? staticSegments.join("_") : null;
};
export const buildViewTypeFromPathname = (pathname: string): string | null => {
    // first segment is the site slug (e.g. konto-mieszkaniowe) - drop it
    const [, ...segments] = pathname.split("/").filter(Boolean);

    const staticSegments = segments.filter((segment) => !/\d/.test(segment)).map((segment) => segment.replace(/-/g, "_"));

    return staticSegments.length > 0 ? staticSegments.join("_") : null;
};
